function pnSwiperA11y() {
 const copy = JSON.parse(document.getElementById('pn-original-product-data').textContent).interface;
 return {prevSlideMessage:copy.previous_slide,nextSlideMessage:copy.next_slide,
 firstSlideMessage:copy.first_slide,lastSlideMessage:copy.last_slide,
 paginationBulletMessage:copy.go_to_slide.replace('{number}','{{index}}'),
 slideLabelMessage:copy.slide_position.replace('{number}','{{index}}').replace('{total}','{{slidesLength}}')};
}
try {

  document.addEventListener('DOMContentLoaded', function () {
    const windowWidth = window.innerWidth;

    if (windowWidth <= 749) {
      let lastState = null;

      function handleScroll() {
        const orderNowSection = document.getElementById('order-now-section');
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const hideOffset = 200;

        const stickyAtc = document.querySelectorAll('.sticky-atc');
        const headerWrapper = document.querySelectorAll('.header-wrapper');

        // Si existe la sección, calcular si estamos dentro
        let isInOrderSection = false;
        if (orderNowSection) {
          const orderNowOffset = orderNowSection.getBoundingClientRect().top + window.scrollY;
          const orderNowHeight = orderNowSection.offsetHeight;

          isInOrderSection =
            scrollPosition + windowHeight / 2 > orderNowOffset - hideOffset &&
            scrollPosition < orderNowOffset + orderNowHeight;
        }

        const shouldShow = scrollPosition > 350 && !isInOrderSection;

        if (shouldShow && lastState !== 'visible') {
          lastState = 'visible';
          fadeIn(stickyAtc, 1000);
          fadeOut(headerWrapper, 1000);
        } else if (!shouldShow && lastState !== 'hidden') {
          lastState = 'hidden';
          fadeOut(stickyAtc, 500);
          fadeIn(headerWrapper, 500);
        }
      }

      window.addEventListener('scroll', handleScroll);
      handleScroll();
    }

    function fadeIn(elements, duration) {
      elements.forEach(function (el) {
        clearTimeout(el.pnFadeTimer);
        el.dataset.pnFadeTarget = 'visible';
        el.style.display = 'block';
        el.style.transition = `opacity ${duration}ms`;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (el.dataset.pnFadeTarget === 'visible') el.style.opacity = '1';
          });
        });
      });
    }

    function fadeOut(elements, duration) {
      elements.forEach(function (el) {
        el.style.transition = `opacity ${duration}ms`;
        clearTimeout(el.pnFadeTimer);
        el.dataset.pnFadeTarget = 'hidden';
        el.style.opacity = '0';
        el.pnFadeTimer = setTimeout(function () {
          if (el.dataset.pnFadeTarget === 'hidden') el.style.display = 'none';
        }, duration);
      });
    }
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.addEventListener('DOMContentLoaded', function () {
    var sectionEl = document.querySelector('.testimonials-2-template--25467727642944__testimonials_VHC4an');
    if (!sectionEl) return;

    function initSwiper() {
      new Swiper('.testimonials-2-template--25467727642944__testimonials_VHC4an .testimonials-swiper', {
      a11y: pnSwiperA11y(),
        slidesPerView: "auto",
        spaceBetween: 24,
        loop: 3 > 3,
        breakpoints: {
          769: {
            slidesPerView: 3,
            spaceBetween: 32
          }
        },
        pagination: {
          el: ".testimonials-2-template--25467727642944__testimonials_VHC4an .swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: '.testimonials-2-template--25467727642944__testimonials_VHC4an .swiper-button-next',
          prevEl: '.testimonials-2-template--25467727642944__testimonials_VHC4an .swiper-button-prev'
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          initSwiper();
          observer.unobserve(sectionEl);
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(sectionEl);
    } else {
      initSwiper();
    }
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.querySelectorAll('.faq-image-template--25467727642944__faq_image_zMbiG6 .question-header').forEach((header, index) => {
    // Open first question by default
    if (index === 0) {
      header.closest('.question-item').classList.add('active');
    }

    header.addEventListener('click', () => {
      const item = header.closest('.question-item');
      const wasActive = item.classList.contains('active');
      
      // Close all items
      document.querySelectorAll('.faq-image-template--25467727642944__faq_image_zMbiG6 .question-item').forEach(item => {
        item.classList.remove('active');
      });
      
      // Toggle clicked item
      if (!wasActive) {
        item.classList.add('active');
      }
    });
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.addEventListener('DOMContentLoaded', function () {
    var sectionEl = document.querySelector('.reviews-carousel-template--25467727642944__reviews_carousel_XpCcQP');
    if (!sectionEl) return;

    function initSwiper() {
      new Swiper('.reviews-carousel-template--25467727642944__reviews_carousel_XpCcQP .reviews-swiper', {
      a11y: pnSwiperA11y(),
        slidesPerView: "auto",
        spaceBetween: 32,
        loop: true,
        pagination: {
          el: ".reviews-carousel-template--25467727642944__reviews_carousel_XpCcQP .swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: '.reviews-carousel-template--25467727642944__reviews_carousel_XpCcQP .swiper-button-next',
          prevEl: '.reviews-carousel-template--25467727642944__reviews_carousel_XpCcQP .swiper-button-prev'
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          initSwiper();
          observer.unobserve(sectionEl);
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(sectionEl);
    } else {
      initSwiper();
    }
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.addEventListener('DOMContentLoaded', function () {
    var sectionEl = document.querySelector('.steps-slider-template--25467727642944__steps_slider_jDdbUQ');
    if (!sectionEl) return;

    function initSwiper() {
      new Swiper('.steps-slider-template--25467727642944__steps_slider_jDdbUQ .steps-swiper', {
      a11y: pnSwiperA11y(),
        slidesPerView: "auto",
        spaceBetween: 24,
        breakpoints: {
          769: {
            slidesPerView: 3,
            spaceBetween: 32
          }
        },
        pagination: {
          el: ".steps-slider-template--25467727642944__steps_slider_jDdbUQ .swiper-pagination",
          clickable: true
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          initSwiper();
          observer.unobserve(sectionEl);
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(sectionEl);
    } else {
      initSwiper();
    }
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.addEventListener('DOMContentLoaded', function () {
    var sectionEl = document.querySelector('.trustpilot-slider-template--25467727642944__trustpilot_slider_KLyhYV');
    if (!sectionEl) return;

    function initSwiper() {
      new Swiper('.trustpilot-slider-template--25467727642944__trustpilot_slider_KLyhYV .trustpilot-swiper', {
      a11y: pnSwiperA11y(),
        slidesPerView: "auto",
        spaceBetween: 24,
        loop: 4 > 6,
        breakpoints: {
          769: {
            slidesPerView: 3,
            spaceBetween: 32
          }
        },
        pagination: {
          el: ".trustpilot-slider-template--25467727642944__trustpilot_slider_KLyhYV .swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: '.trustpilot-slider-template--25467727642944__trustpilot_slider_KLyhYV .swiper-button-next',
          prevEl: '.trustpilot-slider-template--25467727642944__trustpilot_slider_KLyhYV .swiper-button-prev'
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          initSwiper();
          observer.unobserve(sectionEl);
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(sectionEl);
    } else {
      initSwiper();
    }
  });

} catch(error) { console.warn("Original section interaction", error); }
try {

  document.querySelectorAll('.faq-image-bg-template--25467727642944__faq_image_bg_QAyaL4 .question-header').forEach((header, index) => {
    // Open first question by default
    if (index === 0) {
      header.closest('.question').classList.add('active');
    }

    header.addEventListener('click', () => {
      const question = header.closest('.question');
      const wasActive = question.classList.contains('active');
      
      // Close all questions
      question.closest('.questions').querySelectorAll('.question').forEach(q => {
        q.classList.remove('active');
      });

      // Toggle clicked question
      if (!wasActive) {
        question.classList.add('active');
      }
    });
  });

} catch(error) { console.warn("Original section interaction", error); }
/* Begin cat two-hour offer timer */
(() => {
  function start() {
    const hours = document.getElementById('ig-hours');
    const minutes = document.getElementById('ig-minutes');
    const seconds = document.getElementById('ig-seconds');
    if (!hours || !minutes || !seconds || hours.dataset.timerReady) return;
    hours.dataset.timerReady = 'true';
    const duration = 2 * 60 * 60 * 1000;
    const storageKey = 'pawnello-cat-offer-timer-start-v1';
    let started = Date.now();
    try {
      const saved = Number(localStorage.getItem(storageKey));
      if (Number.isFinite(saved) && saved > 0 && saved <= started) started = saved;
      else localStorage.setItem(storageKey, String(started));
    } catch (_) { /* Keep counting when browser storage is unavailable. */ }
    function render() {
      const elapsed = Math.max(0, Date.now() - started);
      const remaining = Math.ceil((duration - elapsed % duration) / 1000);
      hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
      minutes.textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
      seconds.textContent = String(remaining % 60).padStart(2, '0');
    }
    render();
    setInterval(render, 1000);
    document.addEventListener('visibilitychange', render);
    window.addEventListener('pageshow', render);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
/* End cat two-hour offer timer */
